
const SendGridAPITOKEN = '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';
const testKey = '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'
export const SendGridRequestURL = 'https://api.sendgrid.com/v3/';

export const sendGridAxiosConfig = {
    headers: {
        'Authorization': 'Bearer ' + SendGridAPITOKEN
    }
}